import React from 'react';
import '../microbar.scss';
import CustomIcon, { IconType } from '../../custom-icon/custom-icon';
import { ExportAllModal } from '../../../features/reports-and-logs/logs/export/export-all-modal';
import useCustomModal from '../../custom-modal/custom-modal';
import { Tooltip } from 'antd';
import { LogsType } from '../../../../utils/enums';
import { FwVersion } from 'src/dtos/version.dto';

interface ExportModalBodyProps {
    onClose: () => void;
    logType: LogsType;
    activeVersion: FwVersion | undefined;
}

const ExportModalBody: React.FC<ExportModalBodyProps> = ({ onClose, logType, activeVersion }) =>
    <ExportAllModal onClose={onClose} logTypesToExport={[logType]} activeVersion={activeVersion} />;

const createExportModalBody = (logType: LogsType, activeVersion: FwVersion | undefined) =>
    (onClose: () => void): React.ReactElement =>
        <ExportModalBody onClose={onClose} logType={logType} activeVersion={activeVersion} />;

interface ExportAllRecordsAlertProps {
    logType: LogsType;
    activeVersion: FwVersion | undefined;
}
export const ExportAllRecordsAlert: React.FC<ExportAllRecordsAlertProps> = ({logType,activeVersion}) => {
    const [showModal, , contextHolder] = useCustomModal();

    const exportAllLogsRecords = () => {
        showModal({
            wrapClassName: 'export-all-modal-wrapper',
            width: 1140,
            title: 'Export Logs',
            body: createExportModalBody(logType, activeVersion),
            hideConfirmBtns: true
        });
    };

    return <div className="export-all">
                    <span className="message">
                        <span>Results exceeds presentation limit. </span>
                        <Tooltip placement="bottom" overlayClassName="export-notification-tooltip" title={
                            <div>
                                <span>The search results contain more records than presented.</span> <br/>
                                <span>Click Export all records to download a file with all results (up to 1M).</span>
                            </div>
                        }><CustomIcon type={IconType.INFO} className={IconType.INFO}/></Tooltip>
                    </span>
        {logType &&
            <button type="button" className="right action" onClick={() => exportAllLogsRecords()}>Export all records</button>}
        {contextHolder}
    </div>;
};